import styled from 'styled-components';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';
import ContentBlock from '@bitcoin-portal/bitcoincom-pkg-components/dist/ContentBlock';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import { Link } from 'gatsby';

export const StyledSection = styled(Section)`
  display: flex;
  background: var(--Grey-Scale-900, #1c1c1c);
  flex-direction: column;
  align-self: stretch;
  padding: var(--radius-reg, 40px) var(--radius-sml, 20px) !important;
  align-items: flex-start;
  gap: var(--radius-sml, 20px);

  ${media.md`
    padding: var(--large-2, 80px) !important;
    flex-direction: column;
    align-items: center;
    gap: var(--regular, 50px);
    padding-left: 0px !important;
    padding-right: 0px !important;

     
    
  `}
  ${media.lg`
     padding: var(--radius-reg, 100px) var(--radius-sml, 60px) !important;
     flex-direction: row;
     align-items: center;
     
    
  `} 
  ${media.xl`
    padding: var(--xx-large, 125px) var(--large-2, 80px) !important ;
    gap: var(--regular, 50px);
    
  `};
`;

export const StyledContentBlock = styled(ContentBlock)`
  display: flex;

  align-self: stretch;

  gap: 35px;
  flex: 1 0 0;
  flex-direction: column;
  padding: 0px !important;
  ${media.md`
    flex-direction: column;
    align-items: center;
    gap: 80px;
    
  `};
  ${media.lg`
    flex-direction: row;
    align-items: flex-start;
    gap: 15px;
    
  `};
  ${media.xl`

    gap: 20px;
    
  `};
`;

export const Icon = styled.img`
  display: flex;
  width: 88px;
  height: 88px;
  justify-content: center;

  align-items: center;
  flex-shrink: 0;
  aspect-ratio: 1/1;
`;

export const Title = styled.h2`
  color: var(--Grey-Scale-0, #fff);
  font-family: ${props =>
    props.locale === 'ru'
      ? 'Noto Sans, sans-serif'
      : 'Elza Condensed, sans-serif'};
  text-align: center;
  font-style: normal;
  font-size: 50px;
  font-weight: ${props => (props.locale === 'ru' ? 900 : 500)};
  line-height: 85%;
  letter-spacing: -1px;
  text-transform: uppercase;
  margin: 0px;
  ${media.md`
    font-size: 70px;

    line-height: 85%; 
    letter-spacing: -1.4px;
    width: 574px;
  `}
  ${media.lg`
    font-size: 55px;

    letter-spacing: -1.2px;
    width:unset;
  `}
  ${media.xl`
    font-size: 70px;
    
    letter-spacing: -1.4px;
  `}
`;

export const Subtitle = styled.p`
  color: var(--Shades-500, #96949c);
  font-family: 'Satoshi Variable Medium', sans-serif;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 135%;

  margin: 0px;
  letter-spacing: -0.32px;
  ${media.md`
    font-size: 20px;

    line-height: 130%;

  `}
  ${media.lg`
    font-size: 21px;
    

    font-weight: 500;
    line-height: 123%;
  `}
  ${media.xl`
    font-size: 22px;
    
 
    font-weight: 500;
 
  `}
`;

export const Imagewrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 18.457px;
  width: 100%;
  justify-content: center;
  align-items: center;
  background: var(--orange-50, #faf2e8) !important;
  justify-content: center;
  height: 238px !important;
  ${media.md`
    height: 380px !important;
    background: var(--orange-50, #faf2e8);
    width: 450px;
 
  `}
  ${media.lg`
    height: 450px !important;
    background: var(--orange-50, #faf2e8);
    width: 450px;
 
  `}
  ${media.xl`
    height: 514px !important;
    width: calc(50% - 10px);
    background: var(--orange-50, #faf2e8);
 
  `}
`;

export const Image = styled.img`
  height: 239px !important;
  margin-top: -50px;
  position: absolute;
  align-items: center;
  justify-content: center;
  ${media.md`
    height: 391px !important;
    margin-top: -50px;
    width: 262.933px !important;
    
 
  `}
  ${media.lg`
    height: 440px !important;
    width: 291px !important;

    
    
 
  `}
  ${media.xl`
    height: 504.915px !important;
    width: 339px !important;
    
 
  `}
`;

export const StyledButton = styled.a`
  display: none;
  ${media.md`
    display: flex;
    padding: 14px 27.879px;
    justify-content: center;
    align-items: center;
    gap: 9.293px;
    border-radius: 116.162px;
    background: var(--orange-500, #ff9500);
    justify-content: center;
    align-items: center;
    gap: 8px;
    color: var(--Grey-Scale-900, #1c1c1c);
    text-align: center;
    font-family: "Satoshi Variable Medium", sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
    cursor:pointer;
    position: relative;
    overflow: hidden;
    z-index: 1;
    transition: background 0.3s ease, color 0.3s ease;
  
    &:hover {
      background: #ff7c18;
    }
  
    .ripple {
      position: absolute;
      border-radius: 50%;
      transform: scale(0);
      animation: ripple-animation 1.5s ease-out;
      background-color: rgba(204, 85, 0, 0.6);
      pointer-events: none;
      z-index: 0;
    }
  
    @keyframes ripple-animation {
      to {
        transform: scale(4);
        opacity: 0;
      }
    }
  `}
  ${media.lg`
    
  
  `}
  ${media.xl`
    
    
    padding: 14px 27.879px;
  `}
`;

export const Contentwrapper = styled.div`
  display: flex;

  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--small, 25px);
  flex: 1 0 0;
  border-radius: var(--radius-sml, 20px);
  background: var(--Grey-Scale-900, #1c1c1c);
  ${media.md`
    
    padding: 0px 60px;
  `}
  ${media.lg`
    
    padding: 20px 40px;
  `}
  ${media.xl`
    
    padding: 20px 60px;
  `}
`;

export const Textwrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--regular, 50px);
  align-self: stretch;
`;

export const Titlewrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16.6px;
  align-self: stretch;
  ${media.md`
    
    gap: var(--small, 25px);
  `}
`;

export const StyledGatsbyLink = styled(Link)`
  font-size: 16px;
  font-family: 'Satoshi Variable Medium', sans-serif;
  line-height: 22px;
  color: var(--Primary-Skychain, #4169e1);
  background: none;
  box-shadow: none;
  font-weight: 500;
  text-decoration: none;
`;

export const MobileButton = styled.a`
  display: flex;
  height: 48px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 116.162px;
  background: var(--Primary-Satoshi-Orange, #f7931a);
  color: var(--Shades-900, #1c1c1c);
  text-align: center;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;

  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: background 0.3s ease, color 0.3s ease;

  &:hover {
    background: #ff7c18;
  }

  .ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple-animation 1.5s ease-out;
    background-color: rgba(204, 85, 0, 0.6);
    pointer-events: none;
    z-index: 0;
  }

  @keyframes ripple-animation {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
  ${media.md`
    
    display:none;
  `}
`;
